import { useTranslation } from "react-i18next";
import { Landmark, Wallet, UserCheck, Phone, CalendarDays, Receipt } from "lucide-react";
import { Money } from "./Money";

// كل سطر: أيقونة بيضاء بخلفية معتّمة + عنوان رمادي داكن + قيمة سوداء = تباين عالٍ.
const Row = ({ Icon, label, value, mono = false, tone = "slate" }) => {
  const bg = { slate: "bg-slate-900", emerald: "bg-blue-700", sky: "bg-sky-700", amber: "bg-amber-700" }[tone];
  return (
    <div className="flex items-center gap-3 py-2">
      <div className={`grid h-9 w-9 shrink-0 place-content-center rounded-xl text-white shadow-sm ${bg}`}>
        <Icon className="h-4 w-4" />
      </div>
      <div className="min-w-0 flex-1">
        <p className="text-[10px] font-bold uppercase tracking-wide text-slate-500">{label}</p>
        <p className={`truncate text-sm font-black text-slate-900 ${mono ? "font-mono" : ""}`} dir={mono ? "ltr" : undefined}>
          {value || "—"}
        </p>
      </div>
    </div>
  );
};

// إيصال قبض رسمي — ألوان عالية التباين (نص أسود، أيقونات على خلفية داكنة).
export const BillVoucherSlip = ({ bill, cashboxLabel }) => {
  const { t } = useTranslation();
  const SourceIcon = bill.method === "bank" ? Landmark : Wallet;
  return (
    <div className="rounded-2xl border-2 border-slate-300 bg-slate-50 p-4" data-testid="voucher-slip">
      <div className="mb-3 flex items-center justify-between border-b-2 border-slate-300 pb-2">
        <p className="text-[11px] font-black uppercase tracking-widest text-slate-800">
          {t("acct.bills.sign.voucherTitle")}
        </p>
        <p className="rounded-lg bg-slate-900 px-2 py-1 font-mono text-xs font-black text-white" dir="ltr">
          {bill.voucher_number || bill.supplier_invoice_no || bill.entry_number || bill.id.slice(-8)}
        </p>
      </div>
      <div className="grid gap-1 sm:grid-cols-2">
        <Row Icon={CalendarDays} label={t("acct.bills.sign.date")} value={bill.date} mono />
        <Row Icon={Receipt} label={t("acct.bills.sign.amount")} tone="amber"
             value={<Money value={bill.total} currency={bill.currency} className="text-slate-900" />} />
        <Row Icon={SourceIcon} label={t("acct.bills.sign.source")} value={cashboxLabel} tone="sky" />
        <Row Icon={UserCheck} label={t("acct.bills.sign.receiver")} value={bill.receiver_name} tone="emerald" />
        {bill.receiver_phone ? (
          <Row Icon={Phone} label={t("acct.bills.sign.phone")} value={bill.receiver_phone} mono tone="sky" />
        ) : null}
      </div>
      {bill.description ? (
        <p className="mt-3 rounded-xl border border-slate-300 bg-white p-3 text-xs text-slate-900">
          <span className="font-black text-slate-900">{t("acct.bills.sign.for")}: </span>{bill.description}
        </p>
      ) : null}
    </div>
  );
};
